import Vue from 'vue'
import { $addStorageEvent } from '../util/processingData'
import VueRouter from 'vue-router'
import noPage from '../views/noPage.vue'
import Web from '../views/web.vue'
Vue.use(VueRouter)

const routes = [
  {
    // path: '/Web',
    path: '/',
    name: 'Web',
    component: Web,
    children: [{
      path: 'NDAQ',
      name: 'NDAQ',
      component: () => import('../views/NDAQ.vue'),

    },
    {
      path: 'ETH',
      name: 'ETH',
      component: () => import('../views/ETH.vue'),
    }]
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
  },
  {
    path: '/privilegeLevel',
    name: 'PrivilegeLevel',
    component: () => import('../views/privilegeLevel/index.vue'),
  },
  {
    path: '/Bian',
    name: 'Bian',
    component: () => import('../views/BiAnController.vue'),
  },
  {//帮助中心
    path: '/help',
    name: 'help',
    component: () => import('../views/help/index.vue'),
    meta: {//财会人员和匿名人员不能访问
      inaccessible: "accounting",
      roleKey: [`registered`, `advance`, `vip`, `support`, "verifier", `admin`] //可以访问人员
    },
  },
  {//帮助中心历史工单点击跳出详情
    path: '/WorkOrderDetails',
    name: 'WorkOrderDetails',
    meta: {//财会人员和匿名人员不能访问
      inaccessible: "accounting",
      roleKey: [`registered`, `advance`, `vip`, `support`, "verifier", `admin`] //可以访问人员
    },
    component: () => import('../views/WorkOrderDetails/index.vue'),
  },
  {//帮助中心后台管理页面 
    path: '/HelpBackstage',
    name: 'HelpBackstage',
    meta: {
      roleKey: [`support`, `verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/helpBackstage/index.vue'),
  },
  {//帮助中心后台管理页面的详情页面
    path: '/HelpDetails',
    name: 'HelpDetails',
    meta: {
      roleKey: [`support`, `verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/helpDetails/index.vue'),
  },
  {//个人中心
    path: '/personal',
    name: 'personal',
    alias: '/',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },

    // component: Web,
    component: () => import('../views/personal/index.vue'),
  },
  {//留言板后台 WorkOrderDetails
    path: '/messageBoard',
    name: 'messageBoard',
    meta: {
      roleKey: [`support`, `verifier`, `admin`]
    },
    component: () => import('../views/MessageBoard/index.vue'),
  },
  {//自定义订阅 subscribe
    path: '/subscribe',
    name: 'subscribe',
    meta: {
      roleKey: [`advance`, `vip`, `support`, `verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/subscribe/index.vue'),
  },
  {//自定义订阅 、订阅详情页面subscribeDetails 
    path: '/subscribeDetails',
    name: 'subscribeDetails',
    meta: {
      roleKey: [`advance`, `vip`, `support`, `verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/subscribeDetails/index.vue'),
  },
  {//订阅管理后台 subscribeBoard  
    path: '/subscribeBoard',
    name: 'subscribeBoard',
    meta: {
      roleKey: [`verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/subscribeBoard/index.vue'),
  },
  {//订阅发布 报告发布 subscribeRelease 
    path: '/subscribeRelease',
    name: 'subscribeRelease',
    meta: {
      roleKey: [`admin`] //可以访问人员
    },
    component: () => import('../views/subscribeRelease/index.vue'),
  },
  {//订阅 审核页面 subscribAaudit
    path: '/subscribAaudit',
    name: 'subscribAaudit',
    meta: {
      roleKey: [`verifier`, `admin`] //可以访问人员
    },
    component: () => import('../views/subscribAaudit/index.vue'),
  },
  {//支付管理后台 payManagement payHistories
    path: '/payManagement',
    name: 'payManagement',
    meta: {
      roleKey: [`accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/payManagement/index.vue'),
  },
  {//支付历史 payHistories AccountUpgrade
    path: '/payHistories',
    name: 'payHistories',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/payHistories/index.vue'),
  },
  {//账户升级页面  AccountUpgrade
    path: '/AccountUpgrade',
    name: 'AccountUpgrade',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/AccountUpgrade/index.vue'),
  },
  {//后台地址管理页面  管理员 财务可看  
    path: '/BackgroundAddress',
    name: 'BackgroundAddress',
    meta: {
      roleKey: [`accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/backgroundAddress/index.vue'),
  },
  {//后台确认支付  管理员 财务可看 
    path: '/BackendPayment',
    name: 'BackendPayment',
    meta: {
      roleKey: [`accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/backendPayment/index.vue'),
  },
  {//后台退款确认  管理员 财务可看  
    path: '/BackendRefund',
    name: 'BackendRefund',
    meta: {
      roleKey: [`accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/backendRefund/index.vue'),
  },
  {//后台提现 管理员 财务可看  
    path: '/BackendWithdrawal',
    name: 'BackendWithdrawal',
    meta: {
      roleKey: [`accounting`, `admin`] //可以访问人员
    },
    component: () => import('../views/backendWithdrawal/index.vue'),
  },
  {//数据监控  支持及维护人员, 审核者可看 admin后期取消
    path: '/DataMonitoring',
    name: 'DataMonitoring',
    meta: {
      roleKey: [`support`, `admin`] //可以访问人员
    },
    component: () => import('../views/dataMonitoring/index.vue'),
  },
  {//指标解释页面
    path: '/IndexIntroduce',
    name: 'IndexIntroduce',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/indexIntroduce/index.vue'),
  },
  {//充值页面
    path: '/Recharge',
    name: 'Recharge',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/Recharge/index.vue'),
  },
  {//提交txid页面
    path: '/TXID',
    name: 'TXID',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/TXID/index.vue'),
  },
  {//申请提现
    path: '/Withdrawal',
    name: 'Withdrawal',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/Withdrawal/index.vue'),
  },
  {//申请提现历史记录
    path: '/withdrawalRecords',
    name: 'withdrawalRecords',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/withdrawalRecords/index.vue'),
  },
  {//提现订单详情
    path: '/withdrawalDetails',
    name: 'withdrawalDetails',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/withdrawalDetails/index.vue'),
  },
  {//充值记录  
    path: '/RechargeRecord',
    name: 'RechargeRecord',
    meta: {
      roleKey: [`accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/rechargeRecord/index.vue'),
  },
  {//消费记录  subscriptionLetter
    path: '/ConsumptionRecords',
    name: 'ConsumptionRecords',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/consumptionRecords/index.vue'),
  },
  {//站内信  
    path: '/subscriptionLetter',
    name: 'SubscriptionLetter',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/subscriptionLetter/index.vue'),
  },
  {//订阅与告警 
    path: '/Alarm',
    name: 'Alarm',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/Alarm/index.vue'),
  },
  {//发布观察报告 
    path: '/publishObservations',
    name: 'PublishObservations',
    meta: {
      roleKey: [`registered`, `advance`, `vip`, `support`, `verifier`, `accounting`, `admin`], //可以访问人员
    },
    component: () => import('../views/publishObservations/index.vue'),
  },
  
  {
    path: '/',
    // redirect: "/Web"
    redirect: "/"
  },

  {
    path: '*',//404  
    name: 'noPage',
    component: noPage
  },

]

const router = new VueRouter({
  //  hash history
  mode: "history",
  routes
})



// 全局前置守卫  在每次路由跳转前执行一些逻辑
// router.beforeEach((to, from, next) => {
//   $addStorageEvent(1, "permissionMask", JSON.stringify(false))
//   // 想要进入个人中心页面 必须有token
//   let token = localStorage.getItem("token");
//   //当前用户等级
//   let identity = JSON.parse(localStorage.getItem("identity"));

//   // console.log(to.path,3333);
//   //返回首页关闭遮罩
//   if (to.path == "/" || to.path == "/web") {
//     //判断跳转的动态组件还是其他路由页面存不同的显示旗帜
//     $addStorageEvent(1, "routerPage", JSON.stringify("web"))
//     $addStorageEvent(1, "permissionMask", JSON.stringify(false))
//     next();
//   } else if (to.path == `/IndexIntroduce`) {

//     $addStorageEvent(1, "routerPage", JSON.stringify("IndexIntroduce"))

//   } else { //指标介绍和组件页面可以同时存在 
//     $addStorageEvent(1, "routerPage", JSON.stringify("noWeb"))

//   }



//   next();
// });



export default router

// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

// const VueRouterPush = VueRouter.prototype.push//处理重复跳转一个页面报错问题
// VueRouter.prototype.push = function push(to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }
